import { Api } from '@/interface/api';

/**
 * 获取活动列表
 */
const getActivityList: Api = {
    url: '/api/project/proxy/api/informations.json',
    method: 'get',
};

/**
 * 获取活动列表
 */
 const getActivityDetail: Api = {
  url: '/api/project/proxy/api/page-information',
  method: 'get',
};

export { getActivityList, getActivityDetail };
